export enum NavigationDirection {
  PREVIOUS = 'previous',
  NEXT = 'next',
}
